<!-- summary-card-mobile.html - SEM O MODAL -->
<app-card-mask [hasMask]="hasMask || !!data.comingSoon">
  <mat-card class="summary-card-mobile" [style.--border-color]="data.borderColor">
    <!-- Header -->
    <mat-card-header class="card-header">
      <div class="icon-container" mat-card-avatar
           [style.background-color]="getIconBackgroundWithOpacity()">
        <img [src]="data.icon" [alt]="data.title" class="icon">
      </div>
      <mat-card-title class="title">{{ data.title }}</mat-card-title>
      <mat-card-subtitle class="subtitle" *ngIf="data.subtitle">{{ data.subtitle }}</mat-card-subtitle>
    </mat-card-header>

    <mat-divider class="divider-top"></mat-divider>

    <!-- Content -->
    <div class="content-wrapper">
      <mat-card-content class="content">
        <div *ngFor="let item of data.items" class="item-row">
          <span class="item-name">{{ item.name }}</span>
          <span class="item-value">{{ data.comingSoon ? '-' : formatValue(item.value) }}</span>
        </div>
      </mat-card-content>
    </div>

    <mat-divider class="divider-bottom"></mat-divider>

    <!-- Actions -->
    <mat-card-actions class="button-container">
      <!-- Botão de Informação (esquerda) -->
      <button
        mat-icon-button
        class="info-button-mobile"
        (click)="onInfoButtonClick($event)"
        *ngIf="!hasMask"
      >
        <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon">
      </button>

      <!-- Espaço flexível entre os botões -->
      <div class="spacer"></div>

      <!-- Botão Ver Mais (direita) -->
      <button
        mat-button
        class="more-button"
        (click)="onButtonClick()"
        appTrackClick
        [trackEvent]="data.trackEvent || 'card_button_click'"
        [trackCategory]="data.trackCategory || 'dashboard'"
        [trackLabel]="data.trackLabel || data.title"
        *ngIf="!hasMask"
      >
        <mat-icon class="button-icon">arrow_forward</mat-icon>
        <span>{{ getButtonText() }}</span>
      </button>
    </mat-card-actions>
  </mat-card>
</app-card-mask>
